module.exports = __webpack_public_path__ + "img/about_icon_2.fd143377.png";